import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'v8te-active-button',
  templateUrl: 'v8te-active-button.component.html',
  styleUrls: ['./v8te-active-button.component.less', './../../common.less'],
})

export class V8teActiveButtonComponent implements OnInit, OnChanges {
  @Input() buttonText: string = "Valider";
  @Input() minHeight: number = 40;
  @Input() height: number = 67;
  @Input() minWidth: number = 204;
  @Input() width: number = 284;
  @Input() widthPercent: number;
  @Input() primaryColor: string = "#1990FF";
  @Input() secondaryColor: string = "white";
  @Input() textPrimaryColor: string = "white";
  @Input() textSecondaryColor: string = "#1990FF";
  @Input() border: string = "solid 1px #1990FF";
  @Input() radius: number = 10;
  @Input() padding: string = "0px 20px 0px 20px";
  @Input() icon: string = "";
  @Input() iconAlt: string = "";
  @Input() iconPosition: "left" | "right" = "left";
  @Input() active: boolean = true;
  @Input() cursor: string = "pointer";
  @Input() bold: boolean = false;
  @Input() buttonPlus: boolean = false;
  @Input() boxShadow: string = "";
  @Output() createPollEvent = new EventEmitter<boolean>();

  currentBgColor: string;
  currentTextColor: string;
  currentBorder: string;
  currentIcon: string;

  ngOnInit() {
    this.updateColors();
    this.currentBorder = this.border;
    this.currentIcon = this.icon;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['active'] || changes['primaryColor'] || changes['textPrimaryColor'] || changes['secondaryColor'] || changes['textSecondaryColor']) {
      this.updateColors();
    }
  }

  updateColors() {
    if (this.active) {
      this.currentBgColor = this.primaryColor;
      this.currentTextColor = this.textPrimaryColor;
    } else {
      this.currentBgColor = this.secondaryColor;
      this.currentTextColor = this.textSecondaryColor;
    }
  }
}
